import React from "react";
import {Link} from "react-router-dom";
import {Card, Col} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import DimensionInfo from "../models/DimensionInfo"
import DimensionIcon from "./DimensionIcon"
import DimensionControlBlock from "./DimensionControlBlock"
import DimensionFavoriteSwitch from "./DimensionFavoriteSwitch";
import DimensionEnableSwitch from "./DimensionEnableSwitch";
import AuthContext from "../store/AuthContext";
import {BsBookmark, BsBookmarkFill, BsToggleOn, BsToggleOff, BsThreeDots } from 'react-icons/bs';

import './DimensionCard.css';

const DimensionCard: React.FC<{data: DimensionInfo}> = (props) => {
        const authCtx = React.useContext(AuthContext);
/*
    return (
            <div className="block-location-item">
                <Link className="info" to={`/dimension?dim=${props.data.id}`}>
                    <DimensionIcon dimId={props.data.id}/>
                    <p>{props.data.name}</p>
                </Link>
                <DimensionControlBlock dimId={props.data.id}/>
            </div>
    );
*/
    return (
        <Card className="dimension-card">
            <Card.Body className="dimension-card-body">
                <div className="dimension-card-logo-container">
                    <Link to={`/dimension?dim=${props.data.id}`}>
                        <DimensionIcon dimId={props.data.id} />
                    </Link>
                </div>
                <div className="dimension-card-details-body">
                    <Card.Title className="dimension-card-title fs-6">
                        <Link to={`/dimension?dim=${props.data.id}`}>
                            {props.data.name}
                        </Link>
                    </Card.Title>
                    <div className="dimension-card-details-bottom">
                        <div className="dimension-card-description">
                            {props.data.description}
                        </div>
                        {authCtx.account.developer &&
                            <div className="dimension-card-control-block">
                                <div className="dimension-card-control-icon">
                                    <DimensionEnableSwitch dimId={props.data.id}/>
                                </div>
                                {false && <>
                                    <div className="dimension-card-control-icon">
                                        <DimensionFavoriteSwitch dimId={props.data.id} />
                                    </div>
                                    <div className="dimension-card-control-icon">
                                        <BsThreeDots size={24} />
                                    </div>
                                </>}
                            </div>
                        }
                    </div>
                </div>
            </Card.Body>
        </Card>
    );

};

export default DimensionCard;